const RANDOM_LEN = 5
const RANDOM_CHARS = 'abcdefghijklmnopqrstuvwxyz0123456789'

export function createEprintFilename(opts: {
  formatId: string
  ext: string
  dateFormat: (date: Date, format: string) => string
}): string {
  const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX || ''
  const dateString = opts.dateFormat(new Date(), '_yyyy-mm-dd_HH-MM-ss')
  let rString = ''
  for (let i = 0; i < RANDOM_LEN; i++) {
    rString += RANDOM_CHARS[Math.floor(Math.random() * RANDOM_CHARS.length)]
  }
  rString += '_'
  return `${prefix}${rString}${opts.formatId}${dateString}.${opts.ext}`
}
